//CRN_20260508 - Riskline Summaries service (reads from SureSim backend)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, Observable, of, throwError } from 'rxjs';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';
import { SummaryDTO } from '../../models/system/riskline/riskline-summary.dto';

@Injectable({ providedIn: 'root' })
export class RisklineSummariesService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getSummaryForCountry(isoCode: string, language?: string): Observable<SummaryDTO> {
    try {
      if (!isoCode || isoCode.trim()=='')
        throw new Error('RisklineSummariesService.getSummaryForCountry() - isoCode is required');

      const qs=(language && language.trim()!='') ? ('?language=' + encodeURIComponent(language)) : '';

      return this.httpClientService
             .get<SummaryDTO>(environment.eSimApi +
                              eSimApiPaths.RiskIntelligence + '/' +
                              eSimApiPaths.RiskIntelligenceSummaries + '/' +
                              isoCode +
                              qs)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineSummariesService.getSummaryForCountry() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }
}
